import React from 'react'
import { useState } from 'react';
import {Box,Typography} from '@mui/material'
import css from './login.module.css';
import { Link,useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import {BsLockFill as LockIcon} from 'react-icons/bs';
import { Button } from '../../../ui-components';
import { useModal } from '../../../hooks/Context';
// import NewPassword from './NewPassword';
import {NewPassword} from '.';


const lightText:string = "#D2EAE1";
const ResetPassword = () => {
  const navigate = useNavigate();
  const {setModalContent, setShowModal, setShowCancel} = useModal();

  const handleCancel = () => {
   navigate('/login');
  }
  //api usage from here

  // async function postData(url = '', formData) {
  //   const response = await fetch(url, {
  //     method: 'POST',
  //     body: formData
  //   });
  //   function ResetPassword() {
  //     const [responseData, setResponseData] = useState(null);
  //     const handleSubmit = async (e) => {
  //       e.preventDefault();
  //       const formData = new FormData(any.target);
  //       const response = await postData('
  //       //41.138.161.35:8084/api/Applicant/ChangePasswordAsync?', formData);
  //       setResponseData(response);
  //     };

  //   return response.json();
  // }
  
  // }
  
  const handleClick = () => {
    setModalContent(<NewPassword />);
    setShowModal(true) ;
    setShowCancel(false);
  }
  return (
    <Wrapper>
      <div>
        <span>
          <LockIcon/>
        </span>
        <span>
          Reset Password
        </span>

      </div>
      <div>
        <p>
          To access your account, proceed to reset your default password! 
        </p>
        <div>
          <span onClick={handleCancel}>Cancel</span>
          <Button onClick={() => handleClick()}>
            Reset Password
          </Button>
          
        </div>
      </div>
    </Wrapper>

    
  )
}

export default ResetPassword

const Wrapper = styled.div`
  display:flex;
  flex-direction:column;
  width:500px;
  & > div:first-of-type{
      padding:30px 20px;
      border-radius: 8px 8px 0 0;
      background-color:#20BB70;
      color:var(--white-color);
      display:flex;
      gap:30px;
      align-items: center;
  }
  & > div:first-of-type > span:first-of-type{
    display:flex;
    width:45px;
    height:45px;
    justify-content: center;
    align-items:center;
    background-color: #199056;
    font-size:25px;
    border-radius: 5px;
  }
  & > div:first-of-type > span:nth-of-type(2){
    font-size:20px;
    font-weight:bold;
  }
  & > div:nth-of-type(2){
    padding:20px;
    background-color:var(--white-color);
    display:flex;
    flex-direction:column;
    gap:30px;
    min-height:200px;
    width:100%;
  }
  & > div:nth-of-type(2) > p{
    font-size:25px;
  }
  & > div:nth-of-type(2) > div{
    display:flex;
    gap:20px;
    justify-content:flex-end;
    align-items:center;
  }
  & > div:nth-of-type(2) > div > span{
    cursor:pointer;
  }
`